import { Component, OnInit } from '@angular/core';
import { AnimationController } from '@ionic/angular';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent implements OnInit {

  constructor(
    private animationCtrl: AnimationController
  ) { }

  messageList: string[] = [
    "Your customers are waiting, and so are we!",
    "Get ready to sell more with our digital shop!",
    "Your orders are being processed, and so is our love for your business!",
    "We're the secret ingredient to making your sales sizzle!",
    "Your store is online, and so are we!",
    "Stock up, and sell out!",
    "Your customers love you, and so do we!",
    "Sell more, earn more with your digital shop!",
    "Your business is growing, and so is our love for it!",
    "We're your partner in sales and success!",
    "Your digital shop is ready, and so are we!",
    "Sell anywhere, anytime with our app!",
    "Your customers are happy, and so are we!",
    "Finding your perfect customer!",
    "Sell more, stress less with our digital shop!",
    "Your business is booming, and so is our love for it!",
    "Your customers are ready to fall in love with your products!",
    "Get your products ready to steal hearts and make sales!",
    "Your shop is a treasure trove—let's show it off!",
    "Your products are waiting to shine—let's make magic happen!",
    "Shopping has never been this flirty—let's turn up the charm!",
    "Your digital shop is the talk of the town—let's keep it buzzing!",
    "Your customers can't wait—let's give them what they want!",
    "We're here to help you dazzle your customers!",
    "Your sales are about to get a whole lot hotter!",
    "Get ready to sweep your customers off their feet!",
    "Your shop is where dreams turn into sales, stay tuned!",
    "We've got your back, and your sales too!",
    "Your products are ready to shine brighter than ever!",
    "Brace yourself! Your sales are about to take off!",
    "We're turning your ideas into irresistible offers!",
    "Your customers are ready for a shopping love affair!",
    "Your store is like a magnet—let's attract those customers!",
    "Selling is an art, and you're the Picasso!",
    "We're setting the stage for your Seller success story!",
    "Your shop is a heartbeat away from making magic happen!",
    "Your products are ready to woo and wow!",
    "The countdown to your sales success starts now!",
    "Your store is the ultimate destination—let's make it unforgettable!",
    "Your customers are ready to indulge—let's make it happen!",
    "We're about to turn up the excitement, stay with us!",
    "Get ready for a shopping experience that sparkles!",
    "Your digital shop is about to become a sensation!",
    "Let's make your sales the envy of the competition!"
  ];
  message: string = '';
  animation: any;

  ngOnInit() {
    const randomIndex = Math.floor(Math.random() * this.messageList.length);
    this.message = this.messageList[randomIndex];
  }

  fadeOut() {
    const loaderElement = document.querySelector('.loader');
    this.animation = this.animationCtrl.create()
      .addElement(loaderElement)
      .duration(500)
      .easing('ease-out')
      .fromTo('opacity', '1', '0');
    this.animation.play();
  }
}
